export const whitelistedQueryParams = new Set(['openBlockTab']);
